import { axios } from "@/plugins/http-request.js";

const state = {};

const getters = {};
const actions = {
  getFulfillmentOrderList(_, payload) {
    return axios
      .get("/api/fulfillment-order-list", {
        params: payload,
      })
      .then((res) => res.data);
  },
  downloadFulfillmentOrder(context, payload) {
    return axios
      .post(`/api/fulfillment-order-list/download`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  stageStatusChange(context, payload) {
    return axios
      .post(`/api/fulfillment/check_shipments`, payload)
      .then((res) => res.data);
  },
  downloadAWBDetails(context, tracking_no) {
    return axios
      .get(`/api/package-label/download/${tracking_no}`, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  downloadEcomDetails(context, id) {
    return axios
      .get(
        `/api/fulfillment-consignment-customs-docs/ecom/pdf/fulfillment/${id}`,
        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },
  downloadDaDetails(context, id) {
    return axios
      .get(
        `/api/fulfillment-consignment-customs-docs/da/pdf/fulfillment/${id}`,
        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },
  downloadCustomerInvoiceDetails(context, id) {
    return axios
      .get(
        `/api/fulfillment-consignment-customs-docs/customer_invoice/pdf/fulfillment/${id}`,
        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },
  orderTracking(context, id) {
    return axios
      .get(`/api/fulfillment-order-list/timeline/${id}`, {})
      .then((res) => res);
  },
  orderSummary(context, id) {
    return axios
      .get(`/api/fulfillment-order-list/shipment-view/${id}`, {})
      .then((res) => res);
  },
  getOrderDetails(context, payload) {
    return axios
      .post(
        `/api/order-detail?page=${payload.page}&itemsPerPage=${payload.itemsPerPage}&sortDesc=${payload.sortDesc}&mustSort=${payload.mustSort}&multiSort=${payload.multiSort}`,
        payload
      )
      .then((res) => res.data);
  },
  getOrderDetailsExcel(context, data) {
    return axios
      .post(`/api/order-detail?type=${data.type}&pagination=0`, data.payload)
      .then((res) => res.data);
  },
  downloadTrackingTemplate() {
    return axios
      .get(
        `/api/file_download?file_path=app_packages/template/track_shipment_excel_search.xlsx`,

        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },
  statusDisplay(context, id) {
    return axios
      .get(`/api/order-detail/exception/${id}`)
      .then((res) => res.data.data.data);
  },
  getHvLvList(_, payload) {
    return axios
      .get("/api/hvlv", {
        params: payload,
      })
      .then((res) => res.data);
  },
  downloadhvLvTemp(context, payload) {
    return axios
      .get(
        `/api/file_download?file_path=fulfillments/hvlv_upload_template.xlsx`,
        payload,
        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },
  uploadHvLvdataList(_, payload) {
    return axios.post(`api/hvlv/upload`, payload).then((res) => res.data);
  },
  downloadOrderTemplate() {
    return axios
      .get(
        `/api/file_download?file_path=fulfillments/order_upload_template_shipping.xlsx`,
        {
          responseType: "blob",
        }
      )

      .then((res) => res);
  },
  downloadServiceType() {
    return axios
      .get(
        `/api/file_download?file_path=fulfillments/order_upload_template_service_type.xlsx`,
        {
          responseType: "blob",
        }
      )

      .then((res) => res);
  },
  downloadOrderUpload() {
    return axios
      .get(
        `/api/file_download?file_path=fulfillments/order_upload_template.xlsx`,
        {
          responseType: "blob",
        }
      )

      .then((res) => res);
  },
  getFlag(context, id) {
    if (id == undefined) {
      return axios
        .get(`/api/fulfillment/outbound_order_template`)
        .then((res) => res);
    } else {
      return axios
        .get(`/api/fulfillment/outbound_order_template?client_id=${id}`)
        .then((res) => res);
    }
  },
  getclientconfig(context, id) {
    return axios
      .get(
        `/api/fulfillment/outbound_order_template?client_id=${id}&service=duty_handling`
      )
      .then((res) => res);
  },
  uploadorderList(_, payload) {
    return axios
      .post(`api/fulfillment/order_upload`, payload)
      .then((res) => res.data);
  },
  getOrderList(_, payload) {
    return axios
      .get(`api/excel_details?upload_type=${payload.type}`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  getOrderListBulk(_, payload) {
    return axios
      .get(`api/excel_details?multiple_upload_type=${payload.type}`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  downloadOrderFile(_, url) {
    return axios
      .get(`${url}`, {
        responseType: "blob",
      })

      .then((res) => res);
  },
  getFulfillmentOrderSummary(_, payload) {
    return axios
      .get("/api/fulfillment-order-track-count", {
        params: payload,
      })
      .then((res) => res.data);
  },
  getFulfillmentOrdersSummary(_, payload) {
    return axios
      .get("/api/fulfillment/sale_order_count_track", {
        params: payload,
      })
      .then((res) => res.data);
  },
  getMessageRes(_, payload) {
    return axios
      .post(
        `api/excel_responses?page=${payload.page}&itemsPerPage=${payload.itemsPerPage}`,
        payload
      )
      .then((res) => res.data);
  },
  getOrdersList(_, payload) {
    return axios
      .get("/api/fulfillment/sale_order_list", {
        params: payload,
      })
      .then((res) => res.data);
  },
  orderSummaryview(context, payload) {
    return axios
      .post(`/api/fulfillment-order-list/order-view`, payload)
      .then((res) => res);
  },
  manualTriger(context, payload) {
    return axios
      .post(`/api/fulfillment/manual_excel_trigger`, payload)
      .then((res) => res);
  },
};

const mutations = {
  setPreviousRoute(state, route) {
    state.previousRoute = route;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
